module.exports = __webpack_public_path__ + "static/media/safety.63ac5772.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/safety.png
// module id = 39
// module chunks = 0